export default __webpack_public_path__ + "static/media/completed.71503aa4.svg";